module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Shopping/MC-e8b99742867162b7b2be2f501e4f1ea0.svg";